<template>
    <Header class="em-header">
        <div class="em-navs">
            <div class="em-breadcrumb">
                <Breadcrumb>
                    <BreadcrumbItem class="text-333"><Icon type="md-options"></Icon> {{$store.state.parentRouterName}}</BreadcrumbItem>
                    <BreadcrumbItem>{{$route.meta.title}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="em-nav">
                <a href="javascript:void(0)">
                    <Icon type="md-qr-scanner" size="18" v-if="!is_full_screen" @click="toggleFullScreen()"/>
                    <Icon type="md-contract" size="18" v-if="is_full_screen" @click="toggleFullScreen()" />
                </a>
                <Divider type="vertical" />
                <Poptip content="content" trigger="hover" placement="bottom-end">
                    <a href="javascript:void(0)">
                        <Icon type="ios-contact" size="18"/>
                        <span>{{!!$store.state.userinfo?$store.state.userinfo.PartnerName:'未登录'}} ( 合作伙伴 )</span>
                        <Icon type="ios-arrow-down" size="18"></Icon>
                    </a>
                    <template #title>
                        <div class="em-tip-tit">
                            <div class="info">
                                <div class="name">{{ !!$store.state.userinfo ? $store.state.userinfo.real_name:'未登录' }}</div>
                                <div class="position">{{ !!$store.state.userinfo?$store.state.userinfo.mobile: '未设置' }}</div>
                            </div>
                            <div class="avatar"><Icon type="ios-person-outline" size="30"/></div>
                        </div>
                    </template>
                    <template  #content>
                        <div class="em-tip-content">
                            <div class="line" @click="toInfoPage()">
                                <Icon type="ios-medkit-outline" size="18" class="line-icon"/>
                                <span>账号设置</span>
                            </div>
                            <Divider class="em-divider"/>
                            <div class="logout" @click="loginOut">退出</div>
                        </div>
                    </template>
                </Poptip>
            </div>
        </div>
    </Header>
</template>

<script>
import { logout } from '@/apis/public'
export default {
    name: 'Headers',
    components: {

    },
    data () {
        return {
            userinfo : this.$store.state.userinfo,
            is_full_screen: false,
        }
    },
    mounted(){
        document.addEventListener('fullscreenchange', this.handleFullScreenChange);
    },
    methods:{
        toInfoPage(){
            this.$router.push('/setting');
        },
        /**
         功能：全屏
         time: 2025-57-01 16:57:20
         **/
        handleFullScreenChange(){
            if (!document.fullscreenElement) {
                this.is_full_screen = false;
                // 在这里执行退出全屏后的操作
            } else {
                this.is_full_screen = true;
                // 在这里执行进入全屏后的操作
            }
        },
        /**
         功能：全屏
         time: 2025-57-01 16:57:35
         **/
        toggleFullScreen() {
            if (!document.fullscreenElement) {
                this.is_full_screen = true;
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
            } else {
                this.is_full_screen = false;
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        },
        /**
         功能：退出
         time: 2025-57-01 16:57:42
         **/
        loginOut() {
            let that = this;
            this.$Modal.confirm({
                title: '退出',
                content: '您确定要退出吗?',
                onOk: () => {
                    logout().then(e => {
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.$store.commit('SET_TOKEN' , '');
                        that.$store.commit('SET_USERINFO' , '');
                        that.$store.commit('SET_OPEN_NAMES' , 1);
                        that.$store.commit('SET_ACTIVE_NAMES' , 1);
                        that.$store.commit('SET_AUTH' , '');
                        that.$store.commit('SET_ROUTERS' , []);
                        that.$router.push({ path: '/login' })
                    })
                },
                onCancel: () => {}
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
